import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { ScheduleWorkingRoutesListInterface } from "../../../redux/interfaces/expedition.interface";
import ModalList, {
  ModalListItem,
} from "../../../components/misc/ModalList/ModalList";
import {
  fetchAwbHistory,
  fetchTransferRoute,
  getWorkingRoutes,
} from "../../../redux/api/expedition.api";
import CustomButton from "../../../components/CustomButton";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";
import {
  clearScheduleWorkingRoutes,
  setClientsSelectedActiveExpedition,
} from "../../../redux/reducer/expedition.reducer";
import useRoutesHelper from "../../../hooks/useRoutesHelper";
import useTableCtx from "../../../components/tables/tableContext/useTableCtx";

function RouteTransferActiveExpeditionModal() {
  const dispatch = useAppDispatch();
  const { setSelectedItems } = useTableCtx() || {};

  const { routeParams } = useRoutesHelper();

  const {
    expedition: {
      scheduleWorkingRoutes: {
        data: { data: workingRoutes },
      },
      clientsSelectedActiveExpedition,
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const [selectedRoute, setSelectedRoute] =
    useState<ScheduleWorkingRoutesListInterface | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (clientsSelectedActiveExpedition?.[0]?.id_ruta_transfer) {
      const initialSelectedRoute = workingRoutes.find(
        (workingRoute) =>
          workingRoute.id_ruta ===
          clientsSelectedActiveExpedition?.[0]?.id_ruta_transfer,
      );
      if (initialSelectedRoute) {
        setSelectedRoute(initialSelectedRoute);
      }
    }
  }, [clientsSelectedActiveExpedition, workingRoutes]);

  useEffect(() => {
    return () => {
      dispatch(clearScheduleWorkingRoutes());
      setSelectedRoute(null);
    };
  }, [dispatch]);

  const initialClientsRoutesList: ModalListItem[] = useMemo(
    () =>
      workingRoutes.map((item) => {
        const { id_ruta: id, denumire: label } = item;
        return {
          ...item,
          label: `${label}`, // required
          id: id, // required
          backgroundColor: id === selectedRoute?.id_ruta ? "warning" : "info",
        };
      }),
    [workingRoutes, selectedRoute],
  );

  const workingRoutesModalActions = useCallback(
    ({ search }: { search: string }) => {
      if (clientsSelectedActiveExpedition?.length) {
        dispatch(
          getWorkingRoutes({
            page: 1,
            perPage: 50,
            route: search,
            id_nod: clientsSelectedActiveExpedition?.[0]?.id_nod,
          }),
        );
      }
    },
    [clientsSelectedActiveExpedition, dispatch],
  );

  const handleOnSubmit = useCallback(
    async ({ handleClose }: any) => {
      if (!clientsSelectedActiveExpedition || !selectedRoute) {
        return;
      }
      setIsLoading(true);

      const resultAction = await dispatch(
        fetchTransferRoute({
          selectedActiveExpeditions: clientsSelectedActiveExpedition,
          id_ruta: selectedRoute.id_ruta,
          id_client: "all",
        }),
      );

      if (
        checkEndpointStatus(resultAction, fetchTransferRoute) !==
        endpointStatus.pending
      ) {
        setIsLoading(false);
      }

      if (
        checkEndpointStatus(resultAction, fetchTransferRoute) ===
        endpointStatus.fulfilled
      ) {
        const {
          client,
          doc_trans,
          nodDestinatie,
          pctlivrare,
          route,
          status,
          page,
          rowsPerPage,
        } = routeParams;

        dispatch(
          fetchAwbHistory({
            page: page,
            perPage: rowsPerPage,
            doc_trans: doc_trans,
            nodDestinatie: nodDestinatie,
            pctlivrare: pctlivrare,
            status: status,
            id_client: client,
            route: route,
          }),
        );

        setSelectedItems && setSelectedItems([]);
        setSelectedRoute(null);
        handleClose && handleClose();
      }
    },

    [
      clientsSelectedActiveExpedition,
      dispatch,
      routeParams,
      selectedRoute,
      setSelectedItems,
    ],
  );

  const onClose = useCallback(() => {
    dispatch(setClientsSelectedActiveExpedition([]));
    setSelectedRoute(null);
    setSelectedItems && setSelectedItems([]);
  }, [dispatch, setSelectedItems]);

  return (
    <ModalList
      dynamicModalOpen={clientsSelectedActiveExpedition.length > 0}
      onClose={onClose}
      label="Schimbare ruta"
      modalTitle={"Schimbare ruta"}
      searchPlaceholder={"Cauta ruta"}
      items={initialClientsRoutesList}
      modalActions={workingRoutesModalActions}
      selectedItem={{
        id: selectedRoute?.id_ruta || "",
        label: selectedRoute?.denumire || "",
      }}
      setSelectedItem={setSelectedRoute}
      withCloseAfterSelect={false}
      CustomModalFooter={({ handleClose }: any) => (
        <div className="d-flex justify-content-between">
          <CustomButton onClick={handleClose}>Inapoi</CustomButton>
          <CustomButton
            variant="contained"
            loading={isLoading}
            onClick={() => {
              handleOnSubmit({ handleClose });
            }}>
            Salveaza
          </CustomButton>
        </div>
      )}
      CustomOpenModalComponent={() => <></>}
    />
  );
}

export default RouteTransferActiveExpeditionModal;
